import { Colors, Fonts } from '@estee/elc-base-theme';

export const typographyButtonsTheme = `
    border-radius: 4px;
    font-family: ${Fonts.roboto};
    font-weight: 500px;
    text-transform: uppercase;

    &:disabled {
        cursor: not-allowed;
    }
`;

export const buttonTheme = `
    background-color: ${Colors.primary900};
    color: ${Colors.white};
    ${typographyButtonsTheme};

    &:hover {
        background-color: ${Colors.primary800};
    }

    &:active {
        background-color: ${Colors.primary700};
    }

    &:disabled {
        background-color: ${Colors.primary300};
        color: ${Colors.primary600};
    }
    
`;

export const buttonTextTheme = `
    background-color: ${Colors.white};
    color: ${Colors.primary900};
    text-decoration: underline;
    ${typographyButtonsTheme};

    &:hover {
        background-color: ${Colors.primary100};
    }

    &:active {
        background-color: ${Colors.primary200};
    }

    &:disabled {
        background-color: ${Colors.primary300};
        color: ${Colors.primary600};
    }
`;

export const buttonOutlinedTheme = ` 
    border-color: ${Colors.primary900};
    background-color: ${Colors.white};
    color: ${Colors.primary900};
    ${typographyButtonsTheme};

    &:hover {
        background-color: ${Colors.primary100};
    }

    &:active {
        background-color: ${Colors.primary200};
    }

    &:disabled {
        border-color: ${Colors.primary400};
        background-color: ${Colors.white};
        color: ${Colors.primary400};
    }
`;

export const stickyButtonContainerTheme = `
    background-color: ${Colors.white};
    box-shadow: 0 -3px 3px ${Colors.primary400};
`;

export const stickyButtonTheme = buttonTheme;
